import { render } from "./ExamFilesModal.vue?vue&type=template&id=9ba8fce4&scoped=true"
import script from "./ExamFilesModal.vue?vue&type=script&lang=js"
export * from "./ExamFilesModal.vue?vue&type=script&lang=js"

import "./ExamFilesModal.vue?vue&type=style&index=0&id=9ba8fce4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9ba8fce4"]])

export default __exports__